import { render, staticRenderFns } from "./UetsProviderList.vue?vue&type=template&id=3780e176&"
import script from "./UetsProviderList.vue?vue&type=script&lang=js&"
export * from "./UetsProviderList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports